import React from "react";
import CustomCheckbox from "./CustomCheckbox";
import CheckRoundIcon from "../../images/CheckRoundIcon";
import CloseButtonIcon from "../../images/CloseButtonIcon";
import { normalizePublicImageUrl } from "../../utils/imageUrl";

interface SelectableCardProps {
  type: "default" | "check"; // "default" for no checkbox, "check" for checkbox
  label: string;
  imageSrc?: string;
  checked?: boolean;
  correct?: boolean;
  incorrect?: boolean;
  disabled?: boolean;
  //   eslint-disable-next-line no-unused-vars
  onChange?: (checked: boolean) => void;
  onClick?: () => void;
}

const SelectionCard: React.FC<SelectableCardProps> = ({
  type,
  label,
  imageSrc,
  checked = false,
  correct = false,
  incorrect = false,
  disabled = false,
  onChange,
  onClick,
}) => {
  let borderColor = "border-border";
  let bgColor = "bg-white";
  let textColor = "text-textPrimary";
  let icon = null;

  if (correct) {
    // Harmonised success green
    borderColor = "border-2 border-[#27AE60]";
    bgColor = "bg-[#E8F5EC]";
    textColor = "text-[#1E874B]";
    icon = <CheckRoundIcon className=" w-6 h-6" fillColor="#1E874B" />; // Check icon
  } else if (incorrect) {
    // Harmonised error red/pink
    borderColor = "border-2 border-[#C0392B]";
    bgColor = "bg-[#FDE2E2]";
    textColor = "text-[#922B21]";
    icon = <CloseButtonIcon className="w-6 h-6" />; // Error icon
  } else if (checked) {
    borderColor = "border-2 border-secondary-purple";
  }
  if (disabled) {
    borderColor = "border-2 border-border";
    textColor = "text-textPrimary";
    bgColor = "bg-grey-200";
    icon = <CheckRoundIcon className="w-6 h-6" fillColor="rgb(var(--pd-mist))" />;
  }

  return (
    <button
      className={`relative flex  items-center border rounded-lg  shadow-sm transition-all 
       ${imageSrc ? "flex-col items-center justify-center lg:w-fit xl:min-w-72 lg:min-w-56 w-full px-10 py-10" : "flex-row w-full px-8 py-[26px] gap-2"}
       ${!disabled ? "hover:border-secondary" : ""}
       ${borderColor} ${bgColor}`}
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
    >
      {!imageSrc && type === "check" && onChange && (
        <div className="">
          <CustomCheckbox
            checked={checked}
            disabled={disabled}
            onChange={onChange}
          />
        </div>
      )}

      {imageSrc && (
        <img
          src={normalizePublicImageUrl(imageSrc)}
          alt={label}
          className="w-[88px] h-[88px] object-contain mb-10"
        />
      )}
      <div className="w-full flex justify-between items-center">
        <span className={`text-p font-medium ${textColor}`}>{label}</span>

        <span>
          {icon && imageSrc && (
            <span className="absolute top-6 right-6">{icon}</span>
          )}
          {icon && !imageSrc && <span className="">{icon}</span>}
        </span>
      </div>
    </button>
  );
};

export default SelectionCard;
